import axios from 'axios';

export const scanDatabase = async (scanEndpoint /*, exprAttrNames*/) => {
  try {
    const res = await axios.get(
      `http://localhost:3000${scanEndpoint}` /*, {
      params: { ExpressionAttributeNames: exprAttrNames },
    }*/
    );
    // const res = fetch(`http://localhost:3000${scanEndpoint}`, {
    //   method: 'GET',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    // });
    if (res.data.Count) return res.data.Items;
  } catch (error) {
    console.log(error);
  }
};
